import { call, put, takeLatest } from 'redux-saga/effects';
import { Creators, Types } from '../../redux/object/actions';
import {
  fetchObject as fetchObjectApi,
  fetchBoatTypes as fetchBoatTypesApi,
  fetchJettyTypes as fetchJettyTypesApi,
  fetchDriveTypes as fetchDriveTypesApi,
  updateObject as updateObjectApi
} from '../../api/object';

export function* fetchObject(actions) {
  try {
    const response = yield call(fetchObjectApi, { object_id: actions.object_id });
    yield put(Creators.fetchObjectSuccess(response.data));
  } catch (error) {
    let error_message = error && error.response.data.errors;
    yield put(Creators.fetchObjectFailure(error_message));
  }
}

export function* fetchBoatTypes() {
  try {
    const response = yield call(fetchBoatTypesApi, {});
    yield put(Creators.fetchBoatTypesSuccess(response.data));
  } catch (error) {
    let error_message = error && error.response.data.errors;
    yield put(Creators.fetchBoatTypesFailure(error_message));
  }
}

export function* fetchJettyTypes() {
  try {
    const response = yield call(fetchJettyTypesApi, {});
    yield put(Creators.fetchJettyTypesSuccess(response.data));
  } catch (error) {
    let error_message = error && error.response.data.errors;
    yield put(Creators.fetchJettyTypesFailure(error_message));
  }
}

export function* fetchDriveTypes() {
  try {
    const response = yield call(fetchDriveTypesApi, {});
    yield put(Creators.fetchDriveTypesSuccess(response.data));
  } catch (error) {
    let error_message = error && error.response.data.errors;
    yield put(Creators.fetchDriveTypesFailure(error_message));
  }
}

export function* updateObject(actions) {
  try {
    const { history, payload } = actions;
    let payloadClone = {...payload}
    if (payloadClone && payloadClone.object_length) payloadClone.object_length = payloadClone.object_length.replace(',', '.');
    if (payloadClone && payloadClone.object_width) payloadClone.object_width = payloadClone.object_width.replace(',', '.');
    if (payloadClone && payloadClone.object_depth) payloadClone.object_depth = payloadClone.object_depth.replace(',', '.');
    if (payloadClone && payloadClone.object_height) payloadClone.object_height = payloadClone.object_height.replace(',', '.');
    const response = yield call(updateObjectApi, payloadClone);
    yield put(Creators.updateObjectSuccess(response.data));
    history.push('/activate/step/four');
  } catch (error) {
    let error_message = error && error.response.data.errors;
    yield put(Creators.updateObjectFailure(error_message));
  }
}

export function* watchFetchObject() {
  yield takeLatest(Types.FETCH_OBJECT, fetchObject);
}

export function* watchFetchBoatTypes() {
  yield takeLatest(Types.FETCH_BOAT_TYPES, fetchBoatTypes);
}

export function* watchFetchJettyTypes() {
  yield takeLatest(Types.FETCH_JETTY_TYPES, fetchJettyTypes);
}

export function* watchFetchDriveTypes() {
  yield takeLatest(Types.FETCH_DRIVE_TYPES, fetchDriveTypes);
}

export function* watchUpdateObject() {
  yield takeLatest(Types.UPDATE_OBJECT, updateObject);
}


